import { Box, styled } from '@mui/material'
import { useEffect, useState } from 'react'

const Container = styled(Box)(() => ({
    position: 'relative',
    with: '100%',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}))
const ImageBox = styled(Box)(() => ({
    transition: 'transform 0.5s ease-in-out',
}))

function Carousel({
    images,
    timing = 3000,
}: {
    images: string[]
    timing?: number | undefined
}) {
    const [currentIndex, setCurrentIndex] = useState<number>(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => {
                if (prev > images.length - 2) return 0
                else return prev + 1
            })
        }, timing)
        return () => clearInterval(interval)
    }, [images.length, timing])

    return (
        <Container>
            {images.map((url, index) => (
                <ImageBox key={index}>
                    <img
                        src={url}
                        alt={`${index}`}
                        style={
                            currentIndex === index
                                ? { width: '43svw', overflow: 'hidden' }
                                : {
                                      display: 'none',
                                  }
                        }
                    />
                </ImageBox>
            ))}
        </Container>
    )
}
export default Carousel
